const Divider = ({className, width = 1}) => (
  <hr style={{
    border: `${width}px solid var(--gray-light)`,
		opacity: .3
	}} className={className} />
)

export default Divider;